<block-ui>
    <nav class="navbar navbar-expand-lg navbar-light">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">

            </ul>
            <form class="form-inline my-2 my-lg-0">

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <button *ngIf="company" type="button" class="form-control  btn-light shadow-sm btn-st btn-sm" (click)="RiseCreateUpdateModal(crud_content,null,false)" title="Agregar aplicación">
                    <i aria-hidden="true" class="fa fa-plus cursor-hand"></i> Agregar Aplicación
                </button>


                <!-- <button *ngIf="company" type="button" class="form-control ml-1 btn-light shadow-sm btn-st"
                    (click)="RaisedFromEvent()" title="Cambiar de compañía">
                    {{company?.Name}} <span class="badge badge-light" style="background-color: transparent;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-search" viewBox="0 0 16 16">
                            <path
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                    </span>
                </button> -->


            </form>
        </div>
    </nav>



    <div *ngIf="company">
        <div class="row mt-2 ml-3 ">
            <table class="table table-striped table-sm table-hover">
                <thead>
                    <tr>
                        <th scope="col" style="width: 5%;">#</th>
                        <th scope="col" style="width: 20%;">Nombre</th>
                        <th scope="col" style="width: 65%;">Ruta de archivos</th>
                        <th scope="col" class="text-center" style="width: 5%;">Activa</th>
                        <th scope="col" class="text-center" style="width: 5%;">Opciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of applications" class="p-0">
                        <td>{{record.Key}}</td>
                        <td>{{record.Name}}</td>
                        <td>{{record.FilesPath}}</td>
                        <td class="text-center"><i class="fa fa-{{record.Active ? 'check': 'times'}}"></i></td>
                        <td class="justify-content-center option">
                            <a (click)="RiseCreateUpdateModal(crud_content,record,true)" class="fa fa-edit" style="margin: 2px; cursor: pointer; color: #212529; text-decoration: none;" title="Editar aplicació"></a>

                            <a target="_blank" [routerLink]="['/reports-crud',record.CompanyId, record.Id]" class="fa fa-external-link" style="margin: 2px; cursor: pointer; color: #212529; text-decoration: none;" title="Ver reportes"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <!-- MODAL PAR ACREACION EDICION DE COMPANIAS -->
    <ng-template #content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">Seleccionar compañía</h5>
            <button type="button" class="close" aria-label="Close" (click)="GoToHome()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="companyForm">
                <input type="number" style="display: none;" class="form-control form-control-sm" formControlName="Id">
                <div class="form-group">
                    <label for="">Nombre compañía</label>
                    <input type="email" class="form-control form-control-sm" formControlName="Name" (keyup)="FilterCompanyNamesList(companyForm.controls['Name'].value)">
                </div>
            </form>

            <div class="row mt-2" class="tableFixHead">
                <table class="table table-striped table-sm table-hover">
                    <thead style="background-color: #343a40; color: white;">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Nombre</th>
                            <th scope="col" class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of companies" class="p-0" (click)="SelectCompany(record.Id)" style="cursor: pointer;">
                            <td>{{record.Key}}</td>
                            <td>{{record.Name}}</td>
                            <td class="justify-content-center option">
                                <input *ngIf="record.UIsSelected" type="radio" value="{{record.Id}}" style="cursor: pointer;" checked>
                                <input *ngIf="!record.UIsSelected" type="radio" value="{{record.Id}}" style="cursor: pointer;">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-4 offset-sm-4">
                    <button class="form-control form-control-sm  btn-light shadow-sm btn-st ml-auto" type="button" (click)="SetCompany()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-check-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path
                                d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                        Continuar</button>

                </div>
                <div class="col-sm-4" *ngIf="isRaisedFromEvent">
                    <button class="form-control form-control-sm  btn-light shadow-sm btn-st ml-auto" type="button" (click)="DismissCompanyModal()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-x-octagon" viewBox="0 0 16 16">
                            <path
                                d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z" />
                            <path
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                        </svg>
                        Cancelar</button>
                </div>
            </div>
        </div>
    </ng-template>

    <!--MODAL PARA CREACION EDICION DE APLICACIONES-->
    <ng-template #crud_content let-modal>
        <div class="modal-header">
            <h5 class="modal-title">{{isOnEditMode?'Editar aplicación':'Crear Aplicación'}}</h5>
            <button type="button" class="close" aria-label="Close" (click)="CloseCreateUpdateModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="applicationForm">

                <div class="form-group" style="display: none;">
                    <label for="">Id</label>
                    <input type="number" class="form-control form-control-sm" aria-describedby="" formControlName="Id">
                </div>
                <div class="form-group mRequired">
                    <label for="">Nombre</label>
                    <input type="text" class="form-control form-control-sm" aria-describedby="" formControlName="Name">
                </div>
                <div class="form-group mRequired">
                    <label for="">Identificador de aplicación</label>
                    <input readonly type="text" class="form-control form-control-sm" aria-describedby="" formControlName="Id">
                </div>
                <div class="form-group mRequired">
                    <label for="">Ruta de reportes</label>
                    <input type="text" class="form-control form-control-sm" aria-describedby="" formControlName="FilesPath">
                </div>

                <div class="form-check">
                    <input type="checkbox" class="form-check-input" formControlName="Active" style="transform: scale(1.5);">
                    <label class="form-check-label" for="Active">Activo</label>
                </div>

            </form>
            <br>
            <div class="row">
                <div class="col-sm-4 offset-sm-4">

                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="OnclickSaveApp()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar</button>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st" (click)="CloseCreateUpdateModal()"><i class="fa fa-times-circle" aria-hidden="true"></i>
                        Cerrar&nbsp;
                    </button>
                </div>
            </div>
        </div>


    </ng-template>



</block-ui>